<template>
  <div class="quality-assurance-detail">
    <div class="qa-table">
      <el-table border height="100%" :data="qualityList" ref="multipleTable" tooltip-effect="dark"
        header-row-class-name="customHeader" @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" width="55">
        </el-table-column>
        <el-table-column :label="$t('newProjectV2.serialNumber')" align="center" width="50">
          <template slot-scope="{ $index }">
            {{ $index + 1 }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('newProjectV2.rule')" align="left">
          <template slot-scope="{ row }">
            <template v-if="row.code === 'QA-T13' || row.code === 'QA-T14'">
              {{ $i18n.locale === 'zh' ? row.description.split('{percent}')[0] : row.nameEn.split('{percent}')[0]
              }}<el-input-number size="small" @change="percentChange(row)" v-model="row.wordPercent"
                controls-position="right" :min="1" :max="100">
              </el-input-number>{{ $i18n.locale === 'zh' ? row.description.split('{percent}')[1] :
                row.nameEn.split('{percent}')[1] }}
            </template>
            <template v-else>
              {{ $i18n.locale === 'zh' ? row.description : row.nameEn }}
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('newProjectV2.severeLevel')" align="center" width="400">
          <template slot-scope="{ row }">
            <el-select style="width:120px" size="small" v-model="row.grade" @change="gradeChange(row)">
              <el-option v-for="(item, index) in severeLevelList" :key="index" :label="item.desc"
                :value="item.level"></el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="qa-bottom">
      <el-checkbox v-model="openQA" @change="handleOpenQA">{{ $t('newProjectV2.openQa') }}</el-checkbox>
    </div>
  </div>
</template>

<script>
import { queryAllQuality } from '@/services/newProjectApi';

export default {
  name: 'QualityAssuranceDetail',
  props: {
    qaList: {
      type: Array,
      default() {
        return []
      }
    },
    openQa: {
      type: Boolean,
      default() {
        return false;
      },
    }
  },
  data() {
    return {
      severeLevelList: [{
        level: 0,
        desc: this.$t('newProjectV2.slightError')
      }, {
        level: 1,
        desc: this.$t('newProjectV2.generalError')
      }, {
        level: 2,
        desc: this.$t('newProjectV2.seriousError')
      }],
      qualityList: [],
      openQA: this.openQa,
    }
  },
  mounted() {
    this.getAllQuality();
  },
  methods: {
    async getAllQuality() {
      // 获取所有QA
      let { result } = await queryAllQuality({});
      result.forEach((item, index) => {
        //前五个默认为严重错误
        if (index < 5) {
          item.grade = 2
        } else {
          // 其他默认为一般错误
          item.grade = 1;
        }
        if (item.code === 'QA-T13' || item.code === 'QA-T14') {
          // 设置QA的百分比，默认百分之50
          item.wordPercent = 50;
        } else {
          item.wordPercent = 0;
        }
        // 项目的赋值给查询出来的
        this.qaList.forEach(i => {
          if (i.id === item.id) {
            // 设置回显
            item.grade = i.grade;
            item.wordPercent = i.wordPercent;
          }
        });
      });
      this.qualityList = result;

      // 设置回显
      this.$nextTick(() => {
        this.qualityList.forEach(item => {
          this.qaList.forEach(i => {
            if (i.id === item.id) {
              this.$refs.multipleTable.toggleRowSelection(item, true);
            }
          });
        });
      });
    },
    handleSelectionChange(selection) {
      let selAuality = [];
      selection.forEach(item => {
        selAuality.push({
          id: item.id,
          grade: item.grade,
          wordPercent: item.wordPercent,
        });
      });
      this.$emit('selAualityIDChange', selAuality);
    },
    handleOpenQA(newVal) {
      this.$emit('handleOpenQA', newVal);
    },
    // 百分比变化
    percentChange(item) {
      this.$emit('percentChange', item);
    },
    // 等级变化
    gradeChange(item) {
      this.$emit('gradeChange', item);
    },
  },
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>